import { render, staticRenderFns } from "./CurrencyMatrix.vue?vue&type=template&id=2093960c&scoped=true&"
import script from "./CurrencyMatrix.vue?vue&type=script&lang=js&"
export * from "./CurrencyMatrix.vue?vue&type=script&lang=js&"
import style0 from "./CurrencyMatrix.vue?vue&type=style&index=0&id=2093960c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2093960c",
  null
  
)

export default component.exports